import React from "react";
import { type Line } from "./models";

interface Props {
  line: Line
}
const style: React.CSSProperties = {
  fill: "none",
  strokeWidth: 2,
  stroke: "black",
  strokeLinejoin: "round",
  strokeLinecap: "round"
};
const DrawingLine = (props: Props) => {
  const pathData = "M " + props.line.points.map(p => {
    return `${p.x} ${p.y}`;
  })
    .join(" L ");
  return <path style={style} className="path" d={pathData} />;
};

export default DrawingLine;